// Art extracted from a local Tabletop Simulator cache lives in /public/unfathomable-assets
// (git-ignored, private use only). Everything degrades to vector styling when it is absent.
import { useEffect, useState } from "react";

const kBase = `${process.env.PUBLIC_URL ?? ""}/unfathomable-assets`;

export function assetUrl(path: string): string {
  return `${kBase}/${path}`;
}

export const art = {
  board: () => assetUrl("board.jpg"),
  skill: (def: string) => assetUrl(`skills/${def}.jpg`),
  mythos: (id: string) => assetUrl(`mythos/${id}.jpg`),
  waypoint: (id: string) => assetUrl(`waypoints/${id}.jpg`),
  spell: (id: string) => assetUrl(`spells/${id}.jpg`),
  item: (id: string) => assetUrl(`items/${id}.jpg`),
  damage: (id: string) => assetUrl(`damage/${id}.jpg`),
  character: (id: string) => assetUrl(`characters/${id}.jpg`),
  characterSheet: (id: string) => assetUrl(`characters/${id}-sheet.jpg`),
  feat: (id: string) => assetUrl(`feats/${id}.jpg`),
  token: (id: string) => assetUrl(`tokens/${id}.png`),
  loyalty: (t: string) => assetUrl(`loyalty/${t}.jpg`),
  back: (deck: string) => assetUrl(`backs/${deck}.jpg`),
  title: (t: "captain" | "keeper-of-the-tome") => assetUrl(`titles/${t}.jpg`),
};

let probe: Promise<boolean> | null = null;

/** Whether the private art pack is installed (probed once per page load). */
export function useArtAvailable(): boolean {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    if (!probe) {
      probe = new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = assetUrl("tokens/travel.png");
      });
    }
    let alive = true;
    probe.then(v => { if (alive) setOk(v); });
    return () => { alive = false; };
  }, []);
  return ok;
}
